import React from "react";
import "./OfferModal.css";

const OfferModal = ({ show, onHide, offer }) => {
  if (!offer) return null;

  return (
    <div className={`offer-sheet ${show ? "show" : ""}`}>
      <div className="offer-sheet-overlay" onClick={onHide}></div>

      <div className="offer-sheet-content">
        {/* Close button - top right */}
        <div className="offer-sheet-close-row">
          <button onClick={onHide}>Close ✕</button>
        </div>

        <div className="offer-content-wrapper">
          {/* Title above image */}
          <h4 className="offer-title">{offer.title}</h4>

          <div className="offer-image-container">
            <img src={offer.detail_image} alt={offer.title} />
          </div>

          {offer.terms && (
            <div className="offer-terms">
              <h5>Terms and Conditions</h5>
              <div
                className="offer-terms-content"
                dangerouslySetInnerHTML={{ __html: offer.terms }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferModal;